export default __webpack_public_path__ + "static/egg-shell-hero-a11f329c4257e5a074a91e357d14b228.jpg";